import React, { useState, useRef, useEffect } from "react";
import "./Ticketing.css";

const NoteTooltip = ({ note, onClose }) => {
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [onClose]);

  return (
    <div ref={ref} className="note-tooltip">
      <div className="note-tooltip-arrow-border" />
      <div className="note-tooltip-arrow" />
      <div className="note-tooltip-name">{note.created_by_name}</div>
      <div className="note-tooltip-date">{note.created_on}</div>
      <hr className="note-tooltip-divider" />
      <div className="note-tooltip-body">{note.notes}</div>
      {/* {note.updated_on && (
        <div className="note-tooltip-updated">Updated: {note.updated_on}</div>
      )} */}
    </div>
  );
};

const InternalNotes = ({ notes = [] }) => {
  const [activeNoteId, setActiveNoteId] = useState(null);
  const [showAll, setShowAll] = useState(false);

  const sorted = [...notes].sort((a, b) => b.note_order - a.note_order);
  const displayed = showAll ? sorted : sorted.slice(0, 3);

  const toggleNote = (id) => setActiveNoteId(prev => (prev === id ? null : id));

  return (
    <div>
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="note-section-title">Notes</h6>
        {notes.length > 3 && (
          <span className="note-show-toggle" onClick={() => setShowAll(prev => !prev)}>
            <i className={`fa-solid ${showAll ? "fa-chevron-up" : "fa-chevron-down"} note-toggle-icon`} />
            {showAll ? "Show Less" : "Show All"}
          </span>
        )}
      </div>

      {/* Rows */}
        {displayed.length ? (
            <div className="note-table">
            {displayed.map((item, idx) => (
                <div
                key={item.id}
                className="note-row"
                style={{ background: idx % 2 === 0 ? "#fff" : "#f9f9f9" }}
                >
                {/* Left: Name + Time */}
                <div className="note-meta">
                    <div className="note-author">{item.created_by_name}</div>
                    <div className="note-time">{item.created_on}</div>
                </div>

                {/* Eye Icon + Tooltip */}
                <div className="note-eye-wrap">
                    <i
                    className="fa-solid fa-eye note-eye-icon"
                    onClick={() => toggleNote(item.id)}
                    />
                    {activeNoteId === item.id && (
                    <NoteTooltip note={item} onClose={() => setActiveNoteId(null)} />
                    )}
                </div>

                {/* Note Text — 2-line clamp */}
                <div className="note-text-clamp">{item.notes}</div>
                </div>
            ))}
            </div>
        ) : (
        <div className="text-center text-muted py-3" style={{ fontSize: "13px" }}>
          No internal notes available
        </div>
      )}
    </div>
  );
};

export default InternalNotes;